import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ModalService } from '../../services/modal.service';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { Roteamento } from '../../model/roteamento';
import { CadastrosService } from '../../services/cadastros.service';

@Component({
  selector: 'app-roteamento',
  templateUrl: './roteamento.component.html',
  styleUrls: ['./roteamento.component.scss']
})
export class RoteamentoComponent implements OnInit {

  movSub: Subscription;
  roteamento: any[];
  fileReader: FileReader;
  fileToRead: File;

  constructor(
      private spinner: NgxSpinnerService,
      private modalService: ModalService,
      private cadastrosService: CadastrosService,
      private toastr: ToastrService,
      private confirmationDialogService: ConfirmationDialogService
  ){

  }

  ngOnInit() {
    this.getroteamentos();
  }

  async getroteamentos(){

    this.roteamento = [];

    if (this.movSub && this.movSub.closed == false){
      this.movSub.unsubscribe();
    }

    if (!this.movSub || this.movSub.closed){

      this.spinner.show();

      this.movSub = this.cadastrosService.listar("roteamento/list").subscribe(
        (result: any) =>{

          this.roteamento =  result;
          console.log(result);

          this.spinner.hide();

       },error=>{
            console.log(error);
            this.spinner.hide();
       });

    }


  }

  ngOnDestroy(){
    if (this.movSub && this.movSub.closed == false){
      this.movSub.unsubscribe();
    }
  }

  novoroteamento(){
    this.modalService.modalDetalhesRoteamento.emit(null);
  }

  editar(roteamento: Roteamento){
    this.modalService.modalDetalhesRoteamento.emit(roteamento);
  }

  excluir(roteamento: Roteamento){

    this.confirmationDialogService.confirm('Confirmar?', 'Realmente deseja excluir ?')
      .then((confirmed) =>{

        if(confirmed){
          this.cadastrosService.excluir("roteamento/delete", roteamento ).subscribe(
            (result) =>{

              this.toastr.success('Roteamento excluído com sucesso!', 'Sucesso!');
              this.getroteamentos();
              console.log(result);

            },
            error=> {

              this.toastr.error(error.message, 'Erro!');
              console.log(error);

            }
          );
        }

      })
      .catch(() => {
        console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      });

  }


}
